import { FormattedMessage } from "react-intl";
import Header from "components/layout/Header";
import ButtonLink from "components/common/ButtonLink";
import { ROUTE_PATHS } from "const/paths";
import { User } from "@ticketingplatform/api/dist/users/__generated__/User";
import { useTableQueryParams } from "hooks/useTableQueryParams";

import { useUserList, useUserActionColumns } from "./hooks";
import UserTable from "./partials/UserTable";

const UsersList: React.FC = () => {
  const additionalColumns = useUserActionColumns();
  const [{ sortOrder }] = useTableQueryParams<User>();
  const { dataSource, loading, pagination, onChange } = useUserList();

  return (
    <>
      <Header>
        <ButtonLink type="primary" to={ROUTE_PATHS.SettingsUsersCreate}>
          <FormattedMessage defaultMessage="Add new user" />
        </ButtonLink>
      </Header>
      <UserTable
        {...{
          dataSource,
          loading,
          pagination,
          onChange,
          sortOrder,
          additionalColumns,
        }}
      />
    </>
  );
};

export default UsersList;
